/* eslint-disable max-lines-per-function */
import { computed } from 'vue-demi';
import CONST from '../common/constants.js';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
const { usePageType } = require('@fegobull/webapi').use;

export default (props) => {
    const { isPC } = usePageType();

    // 背景色
    const swiperWrapStyle = computed(() => {
        // 自定义主题情况下, 可自由设置背景色
        let color;
        switch (props.theme) {
            case CONST.THEME.BLACK:
                color = '#202020';
                break;
            case CONST.THEME.WHITE:
                color = '#FAFAFA';
                break;
            case CONST.THEME.CUSTOMER:
                color = props.bgColor;
                break;
            default:
                color = '';
        }
        return {
            backgroundColor: color
        };
    });

    // 右侧线颜色
    const splitLineStyle = computed(() => {
        // 自定义主题情况下, 可自由设置背景色
        let color;
        switch (props.theme) {
            case CONST.THEME.BLACK:
                color = '#323232';
                break;
            case CONST.THEME.WHITE:
                color = '#E5E5E5';
                break;
            case CONST.THEME.CUSTOMER:
                color = props.lineColor;
                break;
            default:
                color = '';
        }
        return {
            backgroundColor: color
        };
    });

    // 股票名样式
    const stockNameStyle = computed(() => {
        // 自定义主题情况下, 可自由设置背景色
        let color;
        let fontSize;
        let fontFamily;
        let fontWeight;
        switch (props.theme) {
            case CONST.THEME.BLACK:
                color = '#E5E5E5';
                fontSize = rem.str(isPC ? CONST.STOCK_NAME_FONT_SIZE.WEB : CONST.STOCK_NAME_FONT_SIZE.H5);
                fontWeight = 600;
                break;
            case CONST.THEME.WHITE:
                color = '#262626';
                fontSize = rem.str(isPC ? CONST.STOCK_NAME_FONT_SIZE.WEB : CONST.STOCK_NAME_FONT_SIZE.H5);
                fontWeight = 600;
                break;
            case CONST.THEME.CUSTOMER:
                color = props.stockFontColor;
                fontSize = rem.str(props.stockFontSize);
                fontFamily = props.stockFontFamily;
                fontWeight = 400;
                break;
            default:
                color = '';
                fontSize = '';
                fontWeight = 400;
        }
        return {
            color,
            fontSize,
            fontFamily,
            fontWeight
        };
    });

    const stockPriceStyle = computed(() => {
        let fontSize;
        let fontFamily;
        let fontWeight;
        switch (props.theme) {
            case CONST.THEME.BLACK:
                fontSize = rem.str(isPC ? CONST.STOCK_PRICE_FONT_SIZE.WEB : CONST.STOCK_PRICE_FONT_SIZE.H5);
                fontWeight = 600;
                break;
            case CONST.THEME.WHITE:
                fontSize = rem.str(isPC ? CONST.STOCK_PRICE_FONT_SIZE.WEB : CONST.STOCK_PRICE_FONT_SIZE.H5);
                fontWeight = 600;
                break;
            case CONST.THEME.CUSTOMER:
                fontSize = rem.str(props.stockPriceFontSize);
                fontFamily = props.stockPriceFontFamily;
                fontWeight = 400;
                break;
            default:
                fontSize = '';
                fontWeight = 400;
        }
        return {
            fontSize,
            fontFamily,
            fontWeight
        };
    });

    // 股票走势样式
    const stockTrendStyle = computed(() => {
        // 自定义主题情况下, 可自由设置背景色
        let fontSize;
        let fontFamily;
        switch (props.theme) {
            case CONST.THEME.BLACK:
                fontSize = rem.str(isPC ? CONST.STOCK_TREND_FONT_SIZE.WEB : CONST.STOCK_TREND_FONT_SIZE.H5);
                break;
            case CONST.THEME.WHITE:
                fontSize = rem.str(isPC ? CONST.STOCK_TREND_FONT_SIZE.WEB : CONST.STOCK_TREND_FONT_SIZE.H5);
                break;
            case CONST.THEME.CUSTOMER:
                fontSize = rem.str(props.trendFontSize);
                fontFamily = props.trendFontFamily;
                break;
            default:
                fontSize = '';
        }
        return {
            fontSize,
            fontFamily
        };
    });

    // 涨跌色判断
    const riseFallColor = computed(() => {
        if (props.upDownColor === CONST.UP_DOWN_COLOR.greenUp) {
            return 'slide-stock-info-green-rise-red-fall';
        } else {
            return 'slide-stock-info-red-rise-gree-fall';
        }
    });

    return {
        swiperWrapStyle,
        splitLineStyle,
        stockNameStyle,
        stockPriceStyle,
        stockTrendStyle,
        riseFallColor
    };
};
